// extracted by mini-css-extract-plugin
export var accordion = "_cj-0";
export var chevron = "_cj-3";
export var closed = "_cj-2";
export var content = "_cj-4";
export var open = "_cj-1";
export var rotate = "_cj-5";